import Head from "next/head";
import Magazine from "../../../components/collection/magazine";
import { Breakpoint } from "../../../utils/media-query";

const TheLanguageOfLoveMagazine = () => {
  const [isDesktop, isTablet, isMobile] = Breakpoint();

  return (
    <>
      <Head>
        <title>The Language of Love - Monthly Issue | Aurum Lab</title>
        <meta
          name="description"
          content="Every individual experiences and expresses their love differently. Those love languages are needed to show love and to help connect on a deeper level."
        />
      </Head>
      <main>
        <div className={isDesktop ? "container" : "container-mobile"}>
          <Magazine src="https://e.issuu.com/embed.html?backgroundColor=%23ffffff&backgroundColorFullscreen=%23ffffff&d=the_language_of_love_magazine&doAutoflipPages=true&hideIssuuLogo=true&hideShareButton=true&u=aurumlab" />
        </div>
      </main>
    </>
  );
};
export default TheLanguageOfLoveMagazine;
